import { createAsyncThunk, createSlice, isRejected } from "@reduxjs/toolkit";
import { axiosGet } from "utils/APIHelper";
import { responseTypes, serviceTypes } from "utils/Types";

const initialState: any = {
  propertySnapshot: {
    PROPERTY_CARDS_SNAPSHOT: [],
    PROPERTY_PLAN_SNAPSHOT: []
  },
  showIndividualPropertyLoader: { fetchPropertySnapshot: false, fetchMembers: false },
  members: []
};

export const fetchPropertySnapshot = createAsyncThunk(`fetchPropertySnapshot`, async (data: any, thunkApi) => {
  const { rejectWithValue } = thunkApi;
  const API_URL = `above-property/property/snapshot?innCode=${data?.inncode}`;
  const response: any = await axiosGet(API_URL, serviceTypes.userplan);
  if (response.status !== responseTypes.success) {
    return rejectWithValue(response.response.data);
  }
  return response.data;
});

export const fetchMembers = createAsyncThunk(`fetchMembers`, async (data: any, thunkApi) => {
  const { rejectWithValue } = thunkApi;
  const API_URL = `above-property/members?innCode=${data.innCode}&searchedText=${data.searchedText || ""}&engagements=${
    data.engagements || ""
  }&roles=${data.roles || ""}&roleCategory=${data.roleCategory || ""}&excludeAbovePropertyUsers=${
    data.excludeAbovePropertyUsers
  }`;
  const response: any = await axiosGet(API_URL, serviceTypes.userplan);
  if (response.status !== responseTypes.success) {
    return rejectWithValue(response.response.data);
  }
  return response.data;
});

export const IndividualPropertySlice = createSlice({
  name: "IndividualProperty",
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPropertySnapshot.pending, (state) => {
        state.showIndividualPropertyLoader.fetchPropertySnapshot = true;
      })
      .addCase(fetchPropertySnapshot.fulfilled, (state, action) => {
        state.propertySnapshot = action?.payload;
        state.showIndividualPropertyLoader.fetchPropertySnapshot = false;
      })
      .addCase(fetchMembers.pending, (state) => {
        state.showIndividualPropertyLoader.fetchMembers = true;
      })
      .addCase(fetchMembers.fulfilled, (state, action: any) => {
        state.members = action.payload.members;
        state.showIndividualPropertyLoader.fetchMembers = false;
      })
      .addMatcher(isRejected(fetchPropertySnapshot, fetchMembers), (state) => {
        state.showIndividualPropertyLoader.fetchPropertySnapshot = false;
        state.showIndividualPropertyLoader.fetchMembers = false;
      });
  }
});

export default IndividualPropertySlice.reducer;
export const { reset } = IndividualPropertySlice.actions;
